<div class="row">
  <div
    class="d-flex flex-row justify-content-center align-items-center mb-3"
    [ngClass]="isListViewSelected ? 'col-12' : 'col-6'"
    *ngFor="let item of items | orderBy: ['siteName']"
    (click)="onSelect(item?.siteId, item?.siteName, item?.siteTimeZone)"
  >
    <div
      class="card bg-c-blue order-card w-100 h-100 mr-2 ml-2"
      [ngClass]="{
        'btn-selected': item?.siteId === selectedId,
        'mb-4': !isListViewSelected
      }"
    >
      <img
        src="assets/svg/ico-check-circle.svg"
        *ngIf="item?.siteId === selectedId"
        class="check-circle"
      />
      <div
        class="card-block"
        [ngClass]="{
          'p-3': !isListViewSelected
        }"
      >
        <img
          *ngIf="!isListViewSelected"
          src="assets/svg/ico-building-with-black-circle.svg"
          class="icon-building f-left"
        />
      </div>

      <h2 *ngIf="!isListViewSelected" class="text-left pl-3 mt-4 mb-0 heading2">
        {{ item?.siteName }}
      </h2>

      <div *ngIf="isListViewSelected" class="row pt-4 pb-3 px-2">
        <div class="col-3 text-center">
          <img
            src="assets/svg/ico-building-with-black-circle.svg"
            class="icon-building-2"
          />
        </div>
        <div class="col-6 heading">{{ item?.siteName }}</div>
      </div>
    </div>
  </div>
</div>
